/* eslint-disable */
import apiFactory from './apiFactory';

export default apiFactory({
    apiUrl    : window.APP_CONF.apiUrl,
    apiPrefix : window.APP_CONF.apiPrefix
});
